/*
 * oc-puntos-foto.js — Onisa Coté (05/10/2026). Puntos numerados sobre una foto que responden al toque.
 * Lo usan sections/onisa-coletero-marca.liquid (coletero y gorro: modo «tarjeta») y sections/onisa-set-incluye.liquid
 * (Rituales y Dúos: modo «acercar»), a través de snippets/oc-puntos-foto.liquid. Maqueta aprobada por Adrián el 05/10:
 * https://claude.ai/artifact/TrqgMMPtJiWDVWGsrh6FSf (opción 2 = tarjeta, opción 3 = acercar).
 *
 * Contrato de marcado (atributos data-, sin depender de las clases de cada sección):
 *   [data-oc-pf-root="<sección>"]        raíz de la sección; el valor va al evento de GA4 (coletero, gorro, set)
 *   [data-oc-pf-photo="tarjeta|acercar"] contenedor de la foto (position: relative)
 *   [data-oc-pf-stage]                   capa que se acerca (envuelve la imagen)
 *   [data-oc-pf-dot]  data-z="1.9"       cada punto (button); data-z = cuánto se acerca la foto en ese punto
 *   [data-oc-pf-row] con [data-oc-pf-name] y [data-oc-pf-text]: fila de la lista con el mismo orden que los puntos
 *   [data-oc-pf-card]                    tarjeta (modo tarjeta) · [data-oc-pf-cap] pie con flechas (modo acercar)
 * Medición: evento GA4 «oc_punto_foto» {seccion, punto, modo}, una vez por punto y página. No es una conversión.
 * Movimiento (knowledge/shopify-conventions.md): solo transform y opacity, ≤ 300 ms; con «reducir movimiento», sin transiciones.
 */
(function () {
  if (window.ocPuntosFoto) return;

  function track(name, params) {
    try {
      if (typeof window.ocTrack === 'function') { window.ocTrack(name, params); return; }
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) {}
  }
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  function init(root) {
    if (!root || root.__ocPf) return;
    var photo = root.querySelector('[data-oc-pf-photo]');
    if (!photo) return;
    var modo = photo.getAttribute('data-oc-pf-photo');
    if (modo !== 'tarjeta' && modo !== 'acercar') return;
    root.__ocPf = 1;
    var seccion = root.getAttribute('data-oc-pf-root') || '';
    var dots = [].slice.call(photo.querySelectorAll('[data-oc-pf-dot]'));
    var rows = [].slice.call(root.querySelectorAll('[data-oc-pf-row]'));
    var stage = photo.querySelector('[data-oc-pf-stage]');
    var card = photo.querySelector('[data-oc-pf-card]');
    var cap = photo.querySelector('[data-oc-pf-cap]');
    if (!dots.length || rows.length < dots.length) return;
    var activo = -1, enviados = {};

    function texto(i) {
      var r = rows[i], n = r.querySelector('[data-oc-pf-name]'), t = r.querySelector('[data-oc-pf-text]');
      return { name: n ? n.textContent.trim() : '', text: t ? t.textContent.trim() : '' };
    }
    // Centro del punto en px dentro de la foto (left/top en %; el translate(-50%) no cambia offsetLeft/offsetTop).
    function centro(i) { return { x: dots[i].offsetLeft, y: dots[i].offsetTop }; }

    function marcar(i) {
      dots.forEach(function (d, k) {
        d.setAttribute('aria-expanded', k === i ? 'true' : 'false');
        d.classList.toggle('oc-pf-dim', modo === 'tarjeta' && i > -1 && k !== i);
      });
      rows.forEach(function (r, k) { r.classList.toggle('is-on', k === i); });
    }

    // Tarjeta pegada al punto, encima o debajo; si así taparía otro número, se aparta hasta dejarlo libre.
    function abrirTarjeta(i) {
      var t = texto(i), W = photo.clientWidth, H = photo.clientHeight, c = centro(i);
      card.classList.remove('is-on');
      card.querySelector('[data-oc-pf-card-name]').textContent = t.name;
      card.querySelector('[data-oc-pf-card-text]').textContent = t.text;
      var cw = Math.min(280, W - 24), left = clamp(c.x - cw / 2, 12, W - cw - 12);
      card.style.width = cw + 'px'; card.style.left = left + 'px'; card.style.top = '0px'; card.style.bottom = 'auto';
      var ch = card.offsetHeight;
      var otros = dots.map(function (d, k) { return k === i ? null : centro(k); })
        .filter(function (o) { return o && o.x > left - 20 && o.x < left + cw + 20; });
      function sitio(lado) {
        var edge = lado === 'below' ? c.y + 22 : c.y - 22;
        for (var k = 0; k < 4; k++) {
          var a = lado === 'below' ? edge : edge - ch, b = lado === 'below' ? edge + ch : edge;
          var hit = otros.filter(function (o) { return o.y > a - 20 && o.y < b + 20; }).map(function (o) { return o.y; });
          if (!hit.length) break;
          edge = lado === 'below' ? Math.max.apply(null, hit) + 24 : Math.min.apply(null, hit) - 24;
        }
        return { lado: lado, edge: edge, cabe: lado === 'below' ? edge + ch <= H - 8 : edge - ch >= 8 };
      }
      var pref = c.y > H * 0.55 ? 'above' : 'below', s = sitio(pref);
      if (!s.cabe) {
        var s2 = sitio(pref === 'above' ? 'below' : 'above');
        s = s2.cabe ? s2 : { lado: pref, edge: pref === 'below' ? c.y + 22 : c.y - 22 };
      }
      card.setAttribute('data-side', s.lado);
      if (s.lado === 'above') { card.style.top = 'auto'; card.style.bottom = (H - s.edge) + 'px'; card.style.setProperty('--oc-pf-from', '6px'); }
      else { card.style.top = s.edge + 'px'; card.style.setProperty('--oc-pf-from', '-6px'); }
      card.style.setProperty('--oc-pf-ax', clamp(c.x - left, 14, cw - 14) + 'px');
      void card.offsetWidth;
      card.classList.add('is-on');
    }

    // Acerca la foto a la pieza sin dejar bordes vacíos. El pie va en la mitad contraria a la pieza: si la pieza está
    // en la mitad de abajo de la foto (antifaz y coleteros del Ritual), el pie sube arriba y la pieza queda en la zona libre.
    function acercar(i) {
      var t = texto(i), W = photo.clientWidth, H = photo.clientHeight, c = centro(i);
      var z = parseFloat(dots[i].getAttribute('data-z')) || 2;
      var arriba = c.y > H * 0.5;
      cap.setAttribute('data-pos', arriba ? 'top' : 'bottom');
      var tx = clamp(W / 2 - c.x * z, W - W * z, 0), ty = clamp(H * (arriba ? 0.62 : 0.38) - c.y * z, H - H * z, 0);
      stage.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + z + ')';
      photo.classList.add('is-zoom');
      cap.querySelector('[data-oc-pf-cap-n]').textContent = (i + 1) + ' de ' + dots.length;
      cap.querySelector('[data-oc-pf-cap-name]').textContent = t.name;
      cap.querySelector('[data-oc-pf-cap-text]').textContent = t.text;
    }

    function abrir(i, teclado) {
      activo = i; marcar(i);
      if (modo === 'tarjeta') abrirTarjeta(i);
      else { acercar(i); if (teclado) { var b = cap.querySelector('[data-oc-pf-next]'); if (b) b.focus(); } }
      if (!enviados[i]) { enviados[i] = 1; track('oc_punto_foto', { seccion: seccion, punto: i + 1, modo: modo }); }
    }

    function cerrar(devolverFoco) {
      if (activo < 0) return;
      var antes = activo;
      activo = -1; marcar(-1);
      if (card) card.classList.remove('is-on');
      if (stage) stage.style.transform = '';
      photo.classList.remove('is-zoom');
      if (devolverFoco && dots[antes]) dots[antes].focus();
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) {
        e.stopPropagation();
        if (activo === i && modo === 'tarjeta') cerrar(false);
        else abrir(i, e.detail === 0);
      });
    });
    photo.addEventListener('click', function (e) {
      if (activo < 0 || (cap && cap.contains(e.target))) return;
      cerrar(false);
    });
    if (cap) {
      var mover = function (paso) { return function (e) { e.stopPropagation(); abrir((activo + paso + dots.length) % dots.length, false); }; };
      var prev = cap.querySelector('[data-oc-pf-prev]'), next = cap.querySelector('[data-oc-pf-next]'), close = cap.querySelector('[data-oc-pf-close]');
      if (prev) prev.addEventListener('click', mover(-1));
      if (next) next.addEventListener('click', mover(1));
      if (close) close.addEventListener('click', function (e) { e.stopPropagation(); cerrar(true); });
    }
    document.addEventListener('click', function (e) { if (activo > -1 && modo === 'tarjeta' && !photo.contains(e.target)) cerrar(false); });
    document.addEventListener('keydown', function (e) { if (activo > -1 && e.key === 'Escape') cerrar(true); });
    window.addEventListener('resize', function () { if (activo > -1) abrir(activo, false); });

    // Latido de invitación: una sola vez, cuando la foto entra en pantalla (el CSS lo anula con «reducir movimiento»).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { photo.classList.add('oc-pf-latido'); io.disconnect(); } });
      }, { threshold: 0.6 });
      io.observe(photo);
    }
  }

  function todas() { [].forEach.call(document.querySelectorAll('[data-oc-pf-root]'), init); }
  window.ocPuntosFoto = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  // Editor de temas: la sección se vuelve a pintar al cambiar un ajuste.
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-oc-pf-root]'); if (r) init(r); });
})();
